<template>
	<nav class="navbar navbar-expand-md">
		<img src="/images/logo-other.png" class="navbar-brand" />

		<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#mynavbar">
			<span class="navbar-toggler-icon"><i class="bi-list"></i></span>
		</button>

		<div class="collapse navbar-collapse" id="mynavbar">
			<ul class="navbar-nav ml-auto" id="nav-items">
				<router-link class="nav-item" exact-active-class="active" :to="nav.to" v-for="nav in navs" v-bind:key="nav.id" tag="li">
					{{nav.txt}}
				</router-link>
			</ul>
		</div>
	</nav>
</template>

<script>
	const navs = [
		{
			id: 1,
			to: '/other/home',
			txt: 'Home',
			active: true
		},
		{
			id: 2,
			to: '/other/search',
			txt: 'Search',
			active: false
		},
		{
			id: 3,
			to: '/other/download',
			txt: 'Download',
			active: false
		}
	]

	export default {
		data() {
			return {
				navs: navs
			}
		}
	}
</script>

<style>
</style>